export default __webpack_public_path__ + "static/media/smilingFace.f725006b.png";